import React from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import NavBar from 'components/app-bar/app-bar';
import TimerSection from './timer-section';
import QueuePolicySection from './queue-policy-section';
import ShiftPolicySection from './shift-policy-section';

const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: '600px',
  },
}));

export default function BehaviorPage() {
  const classes = useStyles();
  const params = useParams();
  const courseId = Number(params.courseId);

  return (
    <>
      <NavBar
        title="Office hours behavior"
        back={`/courses/${courseId}/settings`}
      />

      <Box p={2} clone>
        <Paper>
          <Box className={classes.content}>
            <TimerSection courseId={courseId} />
            <QueuePolicySection courseId={courseId} />
            <ShiftPolicySection courseId={courseId} />
          </Box>
        </Paper>
      </Box>
    </>
  );
}
